import { render, staticRenderFns } from "./editBenefit.vue?vue&type=template&id=5bcaa679&scoped=true&"
import script from "./editBenefit.vue?vue&type=script&lang=js&"
export * from "./editBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcaa679",
  null
  
)

export default component.exports